// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UGkE","newExpiryDate":"styles_newExpiryDate__3DVrX","footer":"styles_footer__3re1E"};